import { ApiClient } from '../api';
import { UserContext } from '../components/context/user.context';
import { Injectable, Optional } from '../components/dependency-injection/decorators';
import { BackendEvent } from '../components/event-manager/event/backend.event';
import { Events } from '../components/event-manager/event/events';
import { Logger } from '../components/logger/logger';
import { NpiDto } from '../dto/recs.dto';
import { EventSubscriberInterface } from '../interfaces/components/event-manager/subscriber/event-subscriber.interface';

@Injectable()
export class BackendSubscriber implements EventSubscriberInterface {
  public constructor (
    private readonly apiClient: ApiClient,
    private readonly userContext: UserContext,
    @Optional() private readonly logger?: Logger,
  ) {
  }

  public getSubscribedEvents (): { [key in Events]?: string } {
    return {
      [ Events.BACKEND_EVENT ]: 'onBackendEvent',
    };
  }

  public async onBackendEvent (event: BackendEvent): Promise<void> {
    this.logger?.debug(`Registering event: ${event.getType()} for ad slot ${event.getAdSlotIdentifier()}`);

    return this.apiClient.registerEvent(event.getAdSlotIdentifier(), {
      eventType: event.getType(),
      npis: this.userContext.getNpis().filter((npi) => npi.getEncryptedNumber() !== null).map((npi) => ({
        encryptedNumber: npi.getEncryptedNumber(),
        source: npi.getSource(),
        destination: npi.getDestination(),
      } as NpiDto)),
    });
  }
}
